module.exports = __webpack_public_path__ + "static/media/bg_textura_loja.01af299a.png";